"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfHubSpotPayloadDto = instanceOfHubSpotPayloadDto;
exports.HubSpotPayloadDtoFromJSON = HubSpotPayloadDtoFromJSON;
exports.HubSpotPayloadDtoFromJSONTyped = HubSpotPayloadDtoFromJSONTyped;
exports.HubSpotPayloadDtoToJSON = HubSpotPayloadDtoToJSON;
exports.HubSpotPayloadDtoToJSONTyped = HubSpotPayloadDtoToJSONTyped;
/**
 * Check if a given object implements the HubSpotPayloadDto interface.
 */
function instanceOfHubSpotPayloadDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function HubSpotPayloadDtoFromJSON(json) {
    return HubSpotPayloadDtoFromJSONTyped(json, false);
}
function HubSpotPayloadDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
    };
}
function HubSpotPayloadDtoToJSON(json) {
    return HubSpotPayloadDtoToJSONTyped(json, false);
}
function HubSpotPayloadDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
    };
}
//# sourceMappingURL=HubSpotPayloadDto.js.map